

const scale_rect = (rect, scale) => {
  const x_mp = (rect.x_min + rect.x_max) / 2.;
  const y_mp = (rect.y_min + rect.y_max) / 2.;

  rect.x_min = x_mp + scale.x * (rect.x_min - x_mp);
  rect.x_max = x_mp + scale.x * (rect.x_max - x_mp);
  rect.y_min = y_mp + scale.y * (rect.y_min - y_mp);
  rect.y_max = y_mp + scale.y * (rect.y_max - y_mp);
};

const get_div_bbox_elem = (elem, scale = {x: 1., y: 1.}) => {
  return get_div_bbox({ current: elem }, scale);
};

const get_div_bbox = (react_ref, scale = {x: 1., y: 1.}) => {

  const root_div = document.getElementById("root");
  if (!root_div || !react_ref.current) {
    return null;
  }

  const root_rect = root_div.getBoundingClientRect();
  const rect = react_ref.current.getBoundingClientRect();
  const x = rect.x - root_rect.x;
  const y = rect.y - root_rect.y;

  const result = {
    x_min: x,
    y_min: y,
    x_max: x + rect.width,
    y_max: y + rect.height,
  };

  scale_rect(result, scale);
  return result;
};

/**
 * Gets a bounding box of all child divs w.r.t. document space.
 *
 * @param child_refs: {[React.ref]}
 * @param scale: {{ x: {float}, y: {float}}
 * @return [ { x_min, x_max, y_min, y_max } ]
 */
const get_bounding_div_bbox = (child_refs, scale = { x: 1., y: 1.}) => {

  const root_div = document.getElementById("root");
  if (!root_div) {
    return null;
  }

  for(let i=0; i < child_refs.length; i++) {
    if (!child_refs[i].current) {
      throw new Error("child reference " + i + " is null");
    }
  }

  const root_rect = root_div.getBoundingClientRect();

  const child_rects = child_refs.map(ref => {
    const rect = ref.current.getBoundingClientRect();
    const x = rect.x - root_rect.x;
    const y = rect.y - root_rect.y;
    return {
      x_min: x,
      y_min: y,
      x_max: x + rect.width,
      y_max: y + rect.height,
    };
  });
  const result = Object.assign({}, child_rects[0]);

  child_rects.forEach(rect => {
    result.x_min = Math.min(rect.x_min, result.x_min);
    result.y_min = Math.min(rect.y_min, result.y_min);
    result.x_max = Math.max(rect.x_max, result.x_max);
    result.y_max = Math.max(rect.y_max, result.y_max);
  });

  scale_rect(result, scale);

  return result;
};

export { get_bounding_div_bbox, get_div_bbox, get_div_bbox_elem };
